import { render, staticRenderFns } from "./InvoicesFooter.vue?vue&type=template&id=5339db62&scoped=true"
import script from "./InvoicesFooter.vue?vue&type=script&lang=js"
export * from "./InvoicesFooter.vue?vue&type=script&lang=js"
import style0 from "./InvoicesFooter.vue?vue&type=style&index=0&id=5339db62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5339db62",
  null
  
)

export default component.exports